import { GisLayerConstructorOptions } from './GisLayerConstructorOptions';

export default {
  GisLayer: GisLayerConstructorOptions,
  GisGroupLayer: GisLayerConstructorOptions
};
